import { Center, Flex } from 'styled-system/jsx';
import SanaapLogo from '@/common/assets/icons/sanaapLogo.svg?react';

const SliderHeader = () => {
  return (
    <Flex
      bgColor="gray-4"
      mb="1rem"
      height="66px"
      maxWidth="maxContainer"
      mx="auto"
      alignItems="center"
      justifyContent="center"
    >
      <Center>
        <SanaapLogo />
      </Center>
    </Flex>
  );
};

export default SliderHeader;
